import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide react-query client singleton.
 *
 * Lives in its own module (rather than in `_app`) so non-React code — e.g. the
 * axios response interceptor in `use-api.tsx` — can invalidate queries without
 * creating an import cycle with the app entrypoint.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: (failureCount, error: any) => {
        if (failureCount > 2) return false;

        const method = error?.config?.method?.toLowerCase();
        const idempotentMethods = ['get', 'head', 'options'];
        if (!method || !idempotentMethods.includes(method)) {
          return false;
        }

        // Retry on network errors (status 0), timeouts, or explicit network errors
        if (
          error?.message === 'Network Error' ||
          error?.code === 'ECONNABORTED' ||
          error?.response?.status === 0
        ) {
          return true;
        }

        return false;
      },
    },
  },
});
